import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import styles from './Button.css';

interface IProps {
  type?: 'primary' | 'secondary';
  children: React.ReactNode;
  className?: string;
}

export const Button = ({ type = 'primary', children, className }: IProps) => {
  const { className: rootClassName } = mergeStyles(styles['button'], styles[type], className);

  return (
    <button type="button" className={rootClassName}>
      {children}
    </button>
  );
};
